import { Component, OnInit, Inject } from '@angular/core';
import { VendaPergunta } from 'src/app/models/venda-pergunta';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-cadastrar-questionario-entrega-modal',
  templateUrl: './cadastrar-questionario-entrega-modal.component.html',
  styleUrls: ['./cadastrar-questionario-entrega-modal.component.scss']
})
export class CadastrarQuestionarioEntregaModalComponent implements OnInit {
  pergunta: VendaPergunta;

  tiposPergunta = [
    { id: 0, descricao: 'Sim ou Não' },
    { id: 1, descricao: 'Texto' },
    { id: 2, descricao: 'Ambos' },
  ];

  tipoStatus = [
    { id: 1, descricao: 'Ativo' },
    { id: 0, descricao: 'Bloqueado' }
  ];

  constructor(
    public dialogRef: MatDialogRef<CadastrarQuestionarioEntregaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(this.data) {
      this.pergunta = this.data.pergunta;
    } else {
      this.pergunta = new VendaPergunta();
    }
  }

  salvar() {
    this.dialogRef.close(this.pergunta);
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }


}
